import { render, staticRenderFns } from "./ModalNotification.vue?vue&type=template&id=7e341376&"
import script from "./ModalNotification.vue?vue&type=script&lang=ts&"
export * from "./ModalNotification.vue?vue&type=script&lang=ts&"
import style0 from "./ModalNotification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports